import { IconButton, Menu, MenuContent, MenuItem, MenuTrigger } from '@wundo/ui';
import { EllipsisVertical, FileText, ListChecks } from 'lucide-react';
import { m } from '@/paraglide/messages.js';

export interface MeetingStaffControlProps {
  onTranscript: () => void;
  onTopics: () => void;
}

/**
 * Our own support hatch on the meeting page: the transcript and the topic
 * judgment. Rendered only for a superadmin, signed in as themselves or as the
 * user, and the smallest control in the row, standing among the user's settings.
 */
export function MeetingStaffControl({
  onTranscript,
  onTopics,
}: MeetingStaffControlProps) {
  return (
    <Menu>
      <MenuTrigger
        render={
          <IconButton size='sm' aria-label={m.meeting_staff_menu()}>
            <EllipsisVertical aria-hidden='true' className='size-4' />
          </IconButton>
        }
      />
      <MenuContent align='end'>
        <MenuItem onClick={onTranscript}>
          <FileText aria-hidden='true' />
          {m.meeting_transcript_open()}
        </MenuItem>
        <MenuItem onClick={onTopics}>
          <ListChecks aria-hidden='true' />
          {m.meeting_topics_open()}
        </MenuItem>
      </MenuContent>
    </Menu>
  );
}
